export default __webpack_public_path__ + "static/media/zeroshotbot-header-white-logo.08901c0a.svg";